import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'

import { formatDate, formatNumber } from '@atheneum/api/dist/lib'
import { StatusLabel } from '@components/StatusLabel'

class InvoicesTable extends Component {
  static propTypes = {
    invoices: PropTypes.object,
    staticData: PropTypes.object,
    history: PropTypes.object,
    sidebarStore: PropTypes.object,
    type: PropTypes.string
  }

  renderInvoices = () => {
    const { invoices, staticData, history, sidebarStore, type } = this.props
    const invoiceRows = invoices.map(invoice => {
      let invoiceUrl
      if (invoice.projectId) {
        invoiceUrl = `/project/${invoice.projectId}/invoice/${invoice.id}`
      }
      if (invoice.contractId) {
        invoiceUrl = `/contract/${invoice.contractId}/invoice/${invoice.id}`
      }
      const createdDate = invoice.createdDate
        ? formatDate(invoice.createdDate)
        : '-'
      const documentDate = invoice.documentDate
        ? formatDate(invoice.documentDate)
        : '-'
      const relevantDate = type === 'drafted' ? createdDate : documentDate
      const currency = staticData.names.currencies[invoice.currencyId]
      const netAmount = `${formatNumber(invoice.netAmount)} ${currency}`
      const vatAmount = `${formatNumber(invoice.vatAmount)} ${currency}`
      const grossAmount = `${formatNumber(invoice.grossAmount)} ${currency}`
      const dateCreated = invoice.statusCreatedAt
        ? formatDate(invoice.statusCreatedAt)
        : '-'
      const userCreated = invoice.statusCreatedByName || '-'

      const classes = invoice.isCreditNote ? 'red-text' : ''

      return (
        <tr key={invoice.id} className={classes}>
          <td>
            <span
              className='row--link'
              onClick={() => history.push(invoiceUrl)}
            >
              {invoice.name}
            </span>
          </td>
          <td>
            <span>{relevantDate}</span>
          </td>
          <td>
            <span>{invoice.type}</span>
          </td>
          {type === 'drafted' && (
            <td>
              <span
                className='row--link'
                onClick={() =>
                  sidebarStore.openSidebar({
                    id: invoice.projectId,
                    template: 'project'
                  })
                }
              >
                {invoice.projectName}
              </span>
            </td>
          )}
          <td>
            <StatusLabel
              statusId={invoice.invoiceStatusId}
              statusesType='invoiceStatuses'
              data-cy='invoice-status-label'
            />
          </td>
          <td>{invoice.isWriteOff ? 'Yes' : 'No'}</td>
          <td>
            <span
              className='row--link'
              onClick={() =>
                sidebarStore.openSidebar({
                  id: invoice.invoicingEntityId,
                  template: 'invoicing-entity'
                })
              }
            >
              {invoice.legalName}
            </span>
          </td>
          <td>
            <span>{invoice.approvedBy || '-'}</span>
          </td>
          {type === 'created' && (
            <td>{invoice.invoiceSentToClientDate ? 'Yes' : 'No'}</td>
          )}
          <td className='right-align'>
            <span>{netAmount}</span>
          </td>
          <td className='right-align'>
            <span>{vatAmount}</span>
          </td>
          <td className='right-align'>
            <span>{grossAmount}</span>
          </td>
          <td className='right-align'>
            <span>{dateCreated}</span>
          </td>
          <td className='right-align'>
            <span>{userCreated}</span>
          </td>
        </tr>
      )
    })

    return <tbody>{invoiceRows}</tbody>
  }

  render () {
    const { type } = this.props
    return (
      <table className='table-wrapper'>
        <thead>
          <tr>
            <th>Invoice No.</th>
            <th>{type === 'drafted' ? 'Created ' : 'Document '} date</th>
            <th>Type</th>
            {type === 'drafted' && <th>Project name</th>}
            <th>Status</th>
            <th>Write off</th>
            <th>Invoicing entity</th>
            <th>Approved by</th>
            {type === 'created' && <th>Sent to client</th>}
            <th className='right-align'>Net Amount</th>
            <th className='right-align'>VAT Amount</th>
            <th className='right-align'>Gross Amount</th>
            <th className='right-align'>Date created</th>
            <th className='right-align'>User created</th>
          </tr>
        </thead>
        {this.renderInvoices()}
      </table>
    )
  }
}

export default withRouter(
  inject('staticData', 'sidebarStore')(observer(InvoicesTable))
)
